import { wcheckBpmnAPI } from "./api";

export const getSchemaEditAccess = async () => {
  try {
    const res = await wcheckBpmnAPI.getSchemaEditAccess();
    if (res?.can_edit === true) return true;
    return false;
  } catch (e) {
    return false;
  }
};

export const getSchemas = async () => {
  try {
    const res = await wcheckBpmnAPI.getSchemas();
    return res?.data;
  } catch (e) {
  }
};

export const duplicateBpmnSchema = async (body) => {
  try {
    const res = await wcheckBpmnAPI.duplicateSchema(body);
    if (!res?.status || res.schema_id == null) return null;
    return { schema_id: res.schema_id };
  } catch (e) {
    return null;
  }
};